import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { WorkshopPayService } from './workshoppay.service';

@NgModule({
  providers: [
    WorkshopPayService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class WorkshopPayModule {}
